import React, { useEffect, useState } from 'react';
import { Table, Form, Input, Button, Space, Modal, notification } from 'antd';
import { PlusOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import Layout from '../components/layout';
import { adminCreateProduct, deleteProduct, getProduct, updatedProduct } from '../services/authService';

const AdminProductPage = () => {
  const [products, setProducts] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [currentProduct, setCurrentProduct] = useState(null);
  const [form] = Form.useForm();

  // Columns for the table
  const columns = [
    {
      title: 'Product Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Actions',
      key: 'actions',
      render: (text, record) => (
        <Space>
          <Button
            icon={<EditOutlined />}
            onClick={() => handleEditProduct(record)}
          >
            Edit
          </Button>
          <Button
            icon={<DeleteOutlined />}
            danger
            onClick={() => handleDeleteProduct(record.id)}
          >
            Delete
          </Button>
        </Space>
      ),
    },
  ];

  // Handle form submission to add or update a product
  const handleAddProduct = async (values) => {
    if (currentProduct) {
      // Update existing product
      await updatedProduct({ ...values, id: currentProduct.id });
      setProducts(products.map((product) =>
        product.id === currentProduct.id ? { ...product, ...values } : product
      ));
      notification.success({
        message: 'Product Updated',
        description: 'The product has been successfully updated.',
      });
    } else {
      // Add new product
      const newProduct = await adminCreateProduct(values);
      setProducts([...products, newProduct]);
      notification.success({
        message: 'Product Added',
        description: 'The product has been successfully added to the list.',
      });
    }

    form.resetFields();
    setIsModalVisible(false);
    setCurrentProduct(null);
  };

  const fetchProducts = async () => {
    const allProducts = await getProduct();
    setProducts(allProducts);
  };

  // Handle modal open for adding a new product
  const showAddProductModal = () => {
    setCurrentProduct(null);
    setIsModalVisible(true);
  };

  // Handle modal open for editing an existing product
  const handleEditProduct = (product) => {
    setCurrentProduct(product);
    form.setFieldsValue({
      name: product.name,
      description: product.description,
    });
    setIsModalVisible(true);
  };

  // Handle modal cancel
  const handleCancel = () => {
    setIsModalVisible(false);
    setCurrentProduct(null);
  };

  // Handle product deletion
  const handleDeleteProduct = async (id) => {
    try {
      await deleteProduct({id:id});
      setProducts(products.filter((product) => product.id !== id));
      notification.success({
        message: 'Product Deleted',
        description: 'The product has been successfully deleted.',
      });
    } catch (error) {
      notification.error({
        message: 'Deletion Failed',
        description: 'There was an error deleting the product.',
      });
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  return (
    <Layout>
      <div style={{ padding: '20px' }}>
        <Space style={{ marginBottom: '20px' }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={showAddProductModal}
          >
            Add Product
          </Button>
        </Space>

        <Table
          columns={columns}
          dataSource={products}
          rowKey="id"
          pagination={false}
        />

        <Modal
          title={currentProduct ? 'Edit Product' : 'Add New Product'}
          visible={isModalVisible}
          onCancel={handleCancel}
          footer={null}
        >
          <Form
            form={form}
            layout="vertical"
            onFinish={handleAddProduct}
          >
            <Form.Item
              name="name"
              label="Product Name"
              rules={[{ required: true, message: 'Please input the product name!' }]}
            >
              <Input placeholder="Enter product name" />
            </Form.Item>

            <Form.Item
              name="description"
              label="Description"
              rules={[{ required: true, message: 'Please input the product description!' }]}
            >
              <Input.TextArea placeholder="Enter product description" />
            </Form.Item>

            <Form.Item>
              <Space>
                <Button type="primary" htmlType="submit">
                  {currentProduct ? 'Update Product' : 'Add Product'}
                </Button>
                <Button onClick={handleCancel}>Cancel</Button>
              </Space>
            </Form.Item>
          </Form>
        </Modal>
      </div>
    </Layout>
  );
};

export default AdminProductPage;
